export default "__VITE_ASSET__Bvh7c7gD__"